// extracted by mini-css-extract-plugin
export default {"container":"container-cPh7D","switchEl":"switchEl-wQ2LB","slider":"slider-Wc9x9"};